import React from 'react';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Page from '../../components/Page';
import { AuthAPI } from '../../api';
import { decodeState } from '../../lib/cognito';
import { AuthStore } from '../../store';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ErrorPage from '../../components/ErrorPage';
import Typography from '@material-ui/core/Typography';
import Loader from '../../components/Loader';

// example error url:
// ?error_description=Already+found+an+entry+for+username+Google_104453901673205203973+&error=invalid_request#

const useStyles = makeStyles(theme => ({
  main: {
    paddingLeft: '4.4rem',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
  text: {
    width: '60%',
    margin: '1rem 0',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));

const OAuthLoginPage = ({dispatch, location}) => {
  const history = useHistory();
  const query = new URLSearchParams(location.search);
  const code = query.get('code');
  const errorDescription = query.get('error_description');
  const state = decodeState(query.get('state'));
  const error = query.get('error');
  const redirectTo = (state && state.redirectTo) || '/';
  const classes = useStyles();
  const [errorMessage, setErrorMessage] = useState(error && `${error}: ${errorDescription}`);

  const login = async (code) => {
    try {
      const redirectUrl = window.location.origin + window.location.pathname;
      const { payload } = await AuthAPI.oAuthLogin(code, redirectUrl);
      const { profile, id, token_ttl } = payload;
      dispatch(AuthStore.login(profile, id, token_ttl));
      history.replace(redirectTo);
    } catch (err) {
      console.error(err);   // eslint-disable-line no-console
      //setError('An error occurred logging in.  Please try again.');
      setErrorMessage(err.body ? err.body.message : 'Unable to verify login token');
    }
  };

  if (code) {
    login(code);
  }

  if (errorMessage) {
    return (
      <ErrorPage title="Authentication Error">
        <Typography variant="h1" color="primary" className={classes.text}>
          Whoops! We were not able to log you in.
        </Typography>
        <Typography variant="body2" className={classes.text}>
          The error message was:
        </Typography>
        <Typography variant="body2" className={classes.text}>
          <em>{errorMessage}</em>
        </Typography>
      </ErrorPage>
    );
  }

  return (
    <Page title="Clickability Login">
      <Loader/>
    </Page>
  );
};

OAuthLoginPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

export default connect()(OAuthLoginPage);
